/* eslint-disable no-param-reassign */
const mutations = {
  /**
   * 设置用户信息
   * @param state {Vuex.state}
   * @param info {object} 用户信息
   */
  setUserInfo(state, info) {
    state.USER_INFO = { ...info }
    window.localStorage.setItem('USER_INFO', JSON.stringify({ ...info }))
  },
  /**
   * 设置用户权限
   * @param state
   * @param permissions {string[]} 权限列表
   */
  setUserPermissions(state, permissions) {
    state.USER_PERMISSIONS = permissions
    window.localStorage.setItem('USER_PERMISSIONS', permissions.join(','))
  },
  /**
   * 设置用户所在分组信息
   * @param state
   * @param info {object} 用户组信息
   */
  setUserGroup(state, info) {
    state.USER_GROUP = { ...info }
    window.localStorage.setItem('USER_GROUP', JSON.stringify({ ...info }))
  },
  /**
   * 设置记住密码
   * @param state
   * @param remember
   */
  setRememberPassword(state, remember) {
    state.REMEMBER_PASSWORD = remember
    window.localStorage.setItem('REMEMBER_PASSWORD', remember)
  },
}

export default mutations
